import { profileImgDefault } from 'assets';

export const formatDropdownOptions = (
  options: any,
  value: string,
  label: string,
  avatars?: { [key: string]: string },
  icon?: string
): ISelectOption[] => {
  const newArray: any = [];
  options?.map((item: any) => {
    const entry: any = { value: item[value], label: item[label] };
    if (avatars) {
      entry.icon = avatars[entry.value] || profileImgDefault;
    }
    if (icon) entry.icon = item[icon];
    newArray.push(entry);
  });
  return newArray;
};
